export default "__VITE_ASSET__z25m4SDp__"